import React from 'react';

export function Logo({ size = 40, showText = true, dark = false }) {
  const primary = dark ? '#ffffff' : '#0d5c3b';
  const bg = dark ? '#0d5c3b' : '#ffffff';
  const textColor = dark ? '#ffffff' : '#0d5c3b';

  return (
    <div className="nc-row">
      <svg width={size} height={size} viewBox="0 0 32 32" fill="none">
        <rect x="0" y="0" width="32" height="32" rx="8" fill={primary} />
        <g fill={bg}>
          <rect x="6" y="14" width="20" height="12" rx="2" />
          <polygon points="6,14 16,4 26,14" />
          <rect x="12" y="18" width="8" height="8" rx="4" fill={primary} />
          <rect x="8" y="16" width="4" height="4" rx="1" fill={primary} />
          <rect x="20" y="16" width="4" height="4" rx="1" fill={primary} />
        </g>
        <circle cx="26" cy="10" r="2" fill="#22c55e" />
      </svg>
      {showText && (
        <div>
          <div style={{ fontSize: size * 0.45, fontWeight: 700, color: textColor, lineHeight: 1.1 }}>
            Nossa Cidade
          </div>
          <div style={{ fontSize: size * 0.22, color: dark ? '#9ca3af' : '#6b7280', lineHeight: 1.2 }}>
            Sua cidade. Tudo aqui.
          </div>
        </div>
      )}
    </div>
  );
}
